import React from 'react';
import ValidatedInput from '../../../../../../common/components/ValidatedInput';

const DecimalInput = props => (
  <ValidatedInput
    {...props}
    validation={[
      {
        checkValid: value => value.length <= 6,
        message: 'Please limit your answer to six characters.',
        restrictInput: true,
        events: ['onChange'],
      },
      {
        pattern: /^-?[0-9]{0,6}\.?[0-9]{0,2}$/g,
        message: 'Please enter a valid decimal value.',
        restrictInput: true,
        events: ['onChange'],
      },
      {
        checkValid: value => !isNaN(value),
        message: 'Please enter a valid decimal value.',
        events: ['onBlur'],
      },
      {
        checkValid: value => value.slice(-1) !== '.',
        message: 'Please enter a valid decimal value.',
        events: ['onBlur'],
      },
    ]}
  />
);

export default DecimalInput;



// WEBPACK FOOTER //
// ./src/App/account/components/Surveys/QuestionGroup/InputTypes/DecimalInput.js